import { AbstractControl, ValidatorFn } from '@angular/forms';
import { getMinStraightDays } from '@at/shared';

export const weekRangeDurationValidator = (
  durationControlName: string,
  daysControlName: string,
): ValidatorFn => {
  return (control: AbstractControl<number, number>) => {
    const durationControlValue = control.get(durationControlName)?.value;
    const daysControlValue = control.get(daysControlName)?.value;

    if (
      !daysControlValue ||
      !Array.isArray(daysControlValue) ||
      !durationControlValue ||
      typeof durationControlValue !== 'number'
    )
      return null;

    const minStraightDays = getMinStraightDays(daysControlValue);

    if (durationControlValue > minStraightDays && minStraightDays < 7) {
      return {
        weekDurationMismatch: {
          value: durationControlValue,
          expectedValue: minStraightDays,
        },
      };
    }
    return null;
  };
};
